import React from 'react';
import {connect,ConnectedProps} from 'react-redux';
import {AnyAction, bindActionCreators,Dispatch} from 'redux';

import {updateSetting} from '../actions/settingsActions';
import {StoreState} from '../typescript/storeTypes';
import Toggle from './Toggle';


export class OrderByToggle extends React.PureComponent<Props> {

    onToggleChange = (orderBy: 'tscode'|'person'): void => {
        this.props.updateSetting('defaultOrderBy', orderBy);
    };

    render() {
        return (
            <Toggle value1="tscode" displayValue1="TSCODE"
                    value2="person" displayValue2="PERSON"
                    onChange={this.onToggleChange}
                    currentValue={this.props.defaultOrderBy} />
        );
    }
}

const connector = connect(mapStateToProps, mapDispatchToProps);

type MappedProps = ConnectedProps<typeof connector>;

type Props = MappedProps;

function mapStateToProps(state: StoreState) {
    return {
        defaultOrderBy: state.settings.defaultOrderBy
    };
}

function mapDispatchToProps(dispatch: Dispatch<AnyAction>) {
    return bindActionCreators({updateSetting}, dispatch);
}

export default connector(OrderByToggle);
